module.exports = __webpack_public_path__ + "static/media/user.5a150563.svg";